module.exports = __webpack_public_path__ + "img/pencil.01310650.svg";